/**
 * O motivo do bloqueio vem da API como código estável; a frase é do cliente.
 * Traduzir aqui, e não no servidor, mantém o contrato pequeno e deixa o texto
 * mudar sem deploy de backend.
 */
const MESSAGES = {
  store_closed: 'A lojinha está fechada no momento.',
  out_of_stock: 'Este item está esgotado.',
  not_curated: 'Este item ainda não foi liberado pelo produtor.',
  locked_by_journey: 'Conclua a trilha exigida para resgatar este item.',
  locked_by_mission: 'Conclua a missão exigida para resgatar este item.',
  locked_by_level: 'Alcance o nível exigido para resgatar este item.',
  locked_by_partner: 'Visite os parceiros exigidos para resgatar este item.',
  limit_reached_reward: 'Você já atingiu o limite deste item.',
  limit_reached_item: 'Você já atingiu o limite desta variação.',
  limit_reached_category: 'Você já atingiu o limite desta categoria.',
  limit_reached_partner: 'Você já atingiu o limite de itens deste parceiro.',
  checkin_required: 'Passe pelo estande do parceiro para resgatar este item.'
}

const FALLBACK = 'Este item não está disponível para resgate agora.'

/**
 * @param {string | null | undefined} reason
 * @returns {string}
 */
export function redeemBlockMessage(reason) {
  if (!reason) return FALLBACK

  return MESSAGES[reason] || FALLBACK
}

/**
 * `redeemable` só é falso quando a API disse que é. Ausente — resposta antiga,
 * ou item que não passou pela avaliação — não bloqueia: o resgate ainda é
 * recusado no servidor, e travar o botão por omissão esconderia itens válidos.
 *
 * @param {{ redeemable?: boolean | null }} item
 * @returns {boolean}
 */
export function isRedeemBlocked(item) {
  return item?.redeemable === false
}

/**
 * O preço de resgate de uma variação. Vem da categoria (`price`); `coin` é o
 * valor legado do item e só é lido enquanto a coluna existir — some no fim do
 * deploy em duas fases.
 *
 * Nulo e indefinido caem em zero, que é "grátis" de verdade: categoria com
 * preço zero é legítima.
 *
 * @param {{ price?: number | null, coin?: number | null }} item
 * @returns {number}
 */
export function itemPrice(item) {
  return Number(item?.price ?? item?.coin ?? 0)
}
